// jquery limit
!function ($) {
    $.fn.extend({
        limit: function (limit, element) {
            let interval, self = $(this);
            let substring = function () {
                let val = (typeof self === 'undefined')
                    ? ''
                    : $(self).val();
                let length = val.length;
                if (length > limit) {
                    $(self).val($(self).val().substring(0,limit));
                }
                if (
                    typeof element !== 'undefined'
                    &&
                    $(element).html() !== limit - length
                ) {
                    $(element).html((limit - length <= 0)
                        ? '0'
                        : limit - length
                    );
                }
            };
            $(this).focus(function () {
                interval = window.setInterval(substring, 100);
            }),
            $(this).blur(function () {
                clearInterval(interval), substring();
            });
            substring();
        }
    })
}(jQuery);